import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './StoreAddress.module.scss'

export function Sizes({
	sizes,
}: {
	readonly sizes: string | undefined
}): React.ReactNode {
	if (!sizes) {
		return null
	}

	return <p className={cx(text.bodyM, styles.sizes)}>{sizes}</p>
}
